export default {
  shantoitInvoices: []
}
